/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RasterCategoryDto } from '../../models/raster-category-dto';

export interface UpdateRasterCategory$Params {
  id: string;
      body: RasterCategoryDto
}

export function updateRasterCategory(http: HttpClient, rootUrl: string, params: UpdateRasterCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, updateRasterCategory.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RasterCategoryDto>;
    })
  );
}

updateRasterCategory.PATH = '/v1/rastercategory/{id}';
